<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <div :class="css.container" class="container">
            <!-- 标题 -->
            <div :class="css.title" class="font-variable font-bold color-1">{{ $t("BioTools.DBSNP.DBSNPName") }}</div>
            <div :class="css.descript" class="font-variable font-bold color-1">{{ $t("BioTools.DBSNP.DBSNPPlaceholder") }}</div>

            <!-- 搜索框 -->
            <ToolSearch
                :class="css.search"
                size="large"
                v-model="keyword"
                :placeholder="$t('Placeholder.SearchGeneOrID', 2)"
                @search="methods.search" />

            <!-- 描述信息 -->
            <div :class="css.describes">
                <div>{{ $t("BioTools.DBSNP.Describe") }}</div>
                <div>{{ $t("BioTools.DBSNP.Describe2") }}</div>
            </div>

            <!-- 搜索窗口 -->
            <search-gene-modal ref="modal" trigger="none" :selector="[{ key: 'taxonomy_id', value: '9606' }]" @change="methods.change" />
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 公共组件
import { SearchGeneModal } from "@/components/windows";
import { ToolSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const { refs, watchs, methods } = useComposable();
const { modal, keyword } = refs;

//* 组件卸载时, 移除侦听器
onUnmounted(() => watchs.stop());
</script>
